<mat-form-field [appearance]="appearance" [formGroup]="parentControl" [class]="fieldClass">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <mat-select #selector  (selectionChange)="onSelectionChange($event.value)" [formControlName]="formKey" [multiple]="isMultiple"
    (infiniteScroll)="infiniteScroll()" [complete]="PerPage === options.length-1"
    [required]="isRequired || (control | controlRequired)" [(ngModel)]="selectValue"
    (ngModelChange)="selectValueChange.emit(selectValue)" msInfiniteScroll>
    <mat-option>
      <ngx-mat-select-search [formControl]="searchForm" [placeholderLabel]="searchPlaceHolder"
        [noEntriesFoundLabel]="noEntriesFoundLabel" [disableScrollToActiveOnOptionsChanged]="true"
        [clearSearchInput]="false">
        <!-- <mat-icon ngxMatSelectSearchClear>close</mat-icon> -->
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngIf="showNoneOption" [value]="null" (click)="keepItOpen ? selector.open() : selector.close()">
      None
    </mat-option>
    <mat-option *ngFor="let option of options" [value]="option[bindValue]" (click)="keepItOpen ? selector.open() : selector.close()">

      <ng-container *ngTemplateOutlet="bindKeyTemplate ? bindKeyTemplate: defaultBindKey;context:{option:option}">
      </ng-container>
      <ng-template #defaultBindKey>
        <span>{{option[bindKey]}}</span>
      </ng-template>
     
    </mat-option>
  </mat-select>
  <button mat-button *ngIf="selectValue" matSuffix mat-icon-button aria-label="Clear" 
  (click)="unSelectOption($event)">
  <mat-icon>close</mat-icon>
</button>
  <mat-error>
    <ng-container  *ngTemplateOutlet="errorTemplate ? errorTemplate: defaultErrorTemplate">
    </ng-container>
  </mat-error>
  <mat-hint>
    <ng-container  *ngTemplateOutlet="hintTemplate ? hintTemplate: defaultHintTemplate">
    </ng-container>
  </mat-hint>
  <ng-template #defaultErrorTemplate>
    <ng-container *ngIf="isRequired || (control | controlRequired)">
      {{label}} is<strong> required</strong>
    </ng-container>
  </ng-template>
  <ng-template #defaultHintTemplate>
    Please enter <strong>{{label}}</strong>
  </ng-template>
</mat-form-field>